<template>
  <div class="home-page"></div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import * as types from "../store/types";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      isLoggedIn: types.IS_LOGGED_IN
    })
  },
  methods: {
    ...mapActions({
      login: types.LOGIN_VERIFY,
      getContentList: types.GET_CONTENT_LIST,
      getQuizList: types.GET_QUIZ_LIST,
      logout: types.LOGOUT
    }),
    goLogin() {
      this.login({token: this.$route.query.token})
      .then(response => {
        if(this.$route.query.section > 0) {
          this.$router.push("/class/"+this.$route.query.section);
        } else if(this.$route.query.tryout > 0) {
          this.$router.push("/tryout/"+this.$route.query.tryout);
        } else {
          this.$router.push("/no-subject");
        }
      }).catch(error => {
        this.logout();
        var link = "/login"
        if(this.$route.query.section > 0) {
          link += "?section=" + this.$route.query.section
        } else if(this.$route.query.tryout > 0) {
          link += "?tryout=" + this.$route.query.tryout
        } 
        this.$router.push(link);
      })
    },
    showMessageBox(message, title, variant) {
      this.$bvModal.msgBoxOk(message, {
        title: title,
        size: 'sm',
        buttonSize: 'sm',
        okVariant: variant,
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0',
        centered: true
      })
      .then(value => {
        this.temp = value
      })
      .catch(err => {
        this.temp = err;
      });
    }
  },
  mounted() {
    if(this.$route.query.token) {
      this.goLogin();
    } else {
      if(this.isLoggedIn) {
        if(this.$route.query.section > 0) {
          this.$router.push("/class/"+this.$route.query.section);
        } else if(this.$route.query.tryout > 0) {
          this.$router.push("/tryout/"+this.$route.query.tryout);
        } else {
          this.getContentList({params: {section: 0}})
          .then(response => {
            
          }).catch(error => {
            this.showMessageBox(error, "Failed to get contents", "danger");
          })

          this.getQuizList({params: {section: 0}})
          .then(response => {

          }).catch(error => {
            this.showMessageBox(error, "Failed to get quiz", "danger");
          })
          this.$router.push("/no-subject");
        }
      } else {
        var link = "/login"
        if(this.$route.query.section > 0) {
          link += "?section=" + this.$route.query.section
        } else if(this.$route.query.tryout > 0) {
          link += "?tryout=" + this.$route.query.tryout
        } 
        this.$router.push(link);
      }
    }
  }
};
</script>
